import React from 'react';
import { calculateLevel } from '../utils/badgeSystem';

const UserBadge = ({ postCount, showProgress = false, size = 'md' }) => {
  const levelData = calculateLevel(postCount);
  const { level, progress, postsForNextLevel, progressPercent, badgeInfo } = levelData;

  const sizes = {
    xs: { badge: 'w-6 h-6 text-xs', text: 'text-xs', icon: 'text-sm' },
    sm: { badge: 'w-8 h-8 text-sm', text: 'text-sm', icon: 'text-base' },
    md: { badge: 'w-12 h-12 text-base', text: 'text-sm', icon: 'text-xl' },
    lg: { badge: 'w-16 h-16 text-lg', text: 'text-base', icon: 'text-2xl' },
    xl: { badge: 'w-24 h-24 text-2xl', text: 'text-lg', icon: 'text-4xl' }
  };

  const sizeClasses = sizes[size];

  return (
    <div className="flex items-center space-x-2">
      {/* Badge */}
      <div className="relative group">
        <div
          className={`${sizeClasses.badge} rounded-full bg-gradient-to-br ${badgeInfo.color} flex items-center justify-center font-bold text-white shadow-lg transform transition-all duration-200 group-hover:scale-110 group-hover:shadow-xl`}
          title={`${badgeInfo.name} - Level ${level}`}
        >
          <span className={sizeClasses.icon}>{badgeInfo.icon}</span>
        </div>
        
        {/* Tooltip */}
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:block z-50">
          <div className={`${badgeInfo.bgColor} ${badgeInfo.borderColor} border-2 rounded-lg px-3 py-2 shadow-xl whitespace-nowrap`}>
            <p className={`font-bold ${sizeClasses.text} ${badgeInfo.textColor}`}>
              {badgeInfo.name}
            </p>
            <p className="text-xs text-gray-600">Level {level}</p>
            <p className="text-xs text-gray-500 italic">{badgeInfo.description}</p>
          </div>
        </div>
      </div>

      {/* Level and Progress */}
      {showProgress && (
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-1">
            <span className={`font-bold ${badgeInfo.textColor} ${sizeClasses.text}`}>
              Level {level}
            </span>
            {level < 100 && (
              <span className="text-xs text-gray-500">
                {progress}/{postsForNextLevel}
              </span>
            )}
          </div>
          {level < 120 && (
            <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
              <div
                className={`h-full bg-gradient-to-r ${badgeInfo.color} transition-all duration-500`}
                style={{ width: `${progressPercent}%` }}
              />
            </div>
          )}
          {level === 120 && (
            <p className="text-xs font-bold bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 text-transparent bg-clip-text">
              ✨ IMMORTAL - ULTIMATE LEVEL!
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default UserBadge;
